/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Internal_Code_SaveInputs */

const vi_order_internal_code_save = /** @type {(inputs: Order_Internal_Code_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu mã đơn nội bộ`)
};

/**

* @param {Order_Internal_Code_SaveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_internal_code_save = /** @type {((inputs?: Order_Internal_Code_SaveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Internal_Code_SaveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_internal_code_save(inputs)
});